import { render, staticRenderFns } from "./childrenComponent.vue?vue&type=template&id=d8aa9eec&scoped=true"
import script from "./childrenComponent.vue?vue&type=script&lang=js"
export * from "./childrenComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8aa9eec",
  null
  
)

export default component.exports